var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHipClinical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3311 21.3048C19.4431 20.4808 18.8871 19.3048 18.8871 18.0008C18.8871 16.6968 19.4431 15.5208 20.3311 14.6968C20.5711 14.4728 20.8351 14.2768 21.1191 14.1128C22.0071 13.2888 22.5631 12.1128 22.5631 10.8088C22.5631 8.32078 20.5431 6.30078 18.0511 6.30078C15.5591 6.30078 13.5391 8.32078 13.5391 10.8088C13.5391 12.1128 14.0951 13.2888 14.9831 14.1128C15.2671 14.2768 15.5311 14.4768 15.7711 14.6968C16.6591 15.5208 17.2151 16.6968 17.2151 18.0008C17.2151 19.3048 16.6591 20.4808 15.7711 21.3048C15.5311 21.5288 15.2671 21.7248 14.9831 21.8888C14.0951 22.7128 13.5391 23.8888 13.5391 25.1928C13.5391 27.6808 15.5591 29.7008 18.0511 29.7008C20.5431 29.7008 22.5631 27.6848 22.5631 25.1928C22.5631 23.8888 22.0071 22.7128 21.1191 21.8888C20.8351 21.7248 20.5711 21.5248 20.3311 21.3048Z",
    fill: "#008AED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8121 16.3007C28.2121 17.7287 27.5921 20.3887 24.9761 20.7127C22.3721 20.3327 21.7961 17.6647 23.2201 16.2647C24.2201 15.2807 25.8281 15.2967 26.8121 16.3007Z",
    fill: "#008AED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8121 16.3007C14.2121 17.7287 13.5921 20.3887 10.9761 20.7127C8.3721 20.3327 7.79609 17.6647 9.22009 16.2647C10.2201 15.2807 11.8281 15.2967 12.8121 16.3007Z",
    fill: "#008AED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipClinical);
export default __webpack_public_path__ + "static/media/HIP Clinical.d3d86a65fd3f960784a55ef782f0b236.svg";
export { ForwardRef as ReactComponent };